import { reactive } from 'vue';

const state = reactive({
  open: false,
  listingId: '',
  marketplaceId: '',
  businessProfileId: '',
  ebayAccountId: '',
});

export const openEbayListingDialog = ({
  listingId,
  marketplaceId,
  businessProfileId,
  ebayAccountId,
} = {}) => {
  if (!listingId) return;
  Object.assign(state, {
    listingId: String(listingId),
    marketplaceId: String(marketplaceId ?? ''),
    businessProfileId: String(businessProfileId ?? ''),
    ebayAccountId: String(ebayAccountId ?? ''),
    open: true,
  });
};

export const closeEbayListingDialog = () => {
  state.open = false;
};

export const useEbayListingDialog = () => ({
  state,
  open: openEbayListingDialog,
  close: closeEbayListingDialog,
});
